import React, { useMemo, useCallback } from 'react';
import { useIspmContext } from '../../IspmContext';
import { SEVERITIES_INFO } from '../../../../consts/Severity';
import { countExposuresBySeverity } from '../../common';
import IspmPieWidget from '../../common/widgets/IspmPieWidget';
import { DonutChartData } from '@silverfort/sf-components/dist/Charts/DonutChart/types';
import { bigNumberToText } from '../../../../components/utils';
import { HexColor, SEVERITIES_COLORS, SEVERITY } from '@silverfort/sf-components';
import { addOrRemoveIfPresentFromArray } from '../../../../utils/utils';
import {getInsightStatisticsWithoutHidden} from "../../common/get.insight.statistics.without.hidden";
import { RISKS_FOR_INSIGHTS_TABLE } from '../../../../consts/Insight';

export const IspmRiskLevelWidget = () => {
    const { insightsData, setSeveritiesFilter, severitiesFilter, customInsightsIdsToNames } = useIspmContext();

    const onItemSelected: (filterValue: number) => void = useCallback((filterValue: number) => {
        setSeveritiesFilter(prev => addOrRemoveIfPresentFromArray(filterValue, prev));
    }, [setSeveritiesFilter]);

    const data = useMemo<Array<DonutChartData>>(() => {
        const insightsStatistics = getInsightStatisticsWithoutHidden(insightsData);

        const validInsightEntries = insightsStatistics 
            ? Object.entries(insightsStatistics).filter(([insight]) => 
                RISKS_FOR_INSIGHTS_TABLE.has(insight) || insight in customInsightsIdsToNames
            )
            : [];
        
        const filteredStatistics = Object.fromEntries(validInsightEntries);
        
        const severitiesCount = countExposuresBySeverity(filteredStatistics);

        return [SEVERITY.CRITICAL, SEVERITY.HIGH, SEVERITY.MEDIUM, SEVERITY.LOW].map((severity) => ({
            fill: SEVERITIES_COLORS[severity].hex as HexColor,
            formattedValue: bigNumberToText(severitiesCount[severity]),
            name: SEVERITIES_INFO[severity].label,
            onClick: () => onItemSelected(SEVERITIES_INFO[severity].value),
            value: severitiesCount[severity] ?? 0,
            matchValue: SEVERITIES_INFO[severity].value
        }));
    }, [insightsData, customInsightsIdsToNames, onItemSelected]);

    const selectedItems: Array<number> = severitiesFilter ?? [];

    return <IspmPieWidget data={data} selectedItems={selectedItems} title="Exposed entities by severity" />;
};
